import Analytics from 'analytics'
import googleAnalytics from '@analytics/google-analytics'
import mixpanelPlugin from '@analytics/mixpanel'

const analytics = Analytics({
  app: 'Bubblo+',
  debug: false,
  plugins: [
    mixpanelPlugin({
      token: process.env.VUE_APP_MIXPANEL_TOKEN
    }),
    googleAnalytics({
      trackingId: process.env.VUE_APP_GA_TRACKING_ID,
      autoTrack: {
        exception: true,
        exceptionLogs: true,
        screenview: true,
        page: true
      }
    })
  ]
})

export default analytics
